import React, {useEffect, useState} from 'react';
import {searchBlogPostsWithSearchCriteria, updateSingleBlogPost} from "../../services/blog-post-data-service";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {BLOG_POST_FIELDS_LIST, BLOG_POST_INPUT_FIELDS} from "../../constants/blog.constant";
import AddEditBlogPost from "./add-edit-blog-post";
import RenderFields from "../../../common/ui/render-fields";
import _ from "lodash";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import AddMultipleBlogPosts from "./add-multiple-blog-posts";
import {addSingleContentConfig, getSingleContentConfig} from "../../services/content-config-data-service";
import {CONTENT_CONFIG_KEYS, CONTENT_CONFIG_TYPES} from "../../constants/content.constant";
import {prepareBlogPostFilters} from "../../utils/blog-util";
import GenerateBlogPostContent from "./generate-blog-post-content";
import {searchPromptsWithSearchCriteria} from "../../services/prompt-data-service";
import ShowLink from "../../../common/ui/show-link";

const defaultFilterCriteria: any = {}
const emptyFilterCriteria: any = {}

const BlogPostsList = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [blogPostsList, setBlogPostsList] = useState(null);
    const [blogPostFilters, setBlogPostFilters] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);
    const [blogPostCategoryConfig, setBlogPostCategoryConfig] = useState(null);
    const [promptsList, setPromptsList] = useState(null);

    useEffect(() => {
        if (initialStep) {
            getCategoryConfig();
            getPromptList();
            setInitialStep(false);
        }

    }, [initialStep]);

    useEffect(() => {
        getBlogPostList();
    }, [filterCriteria]);

    const getPromptList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [
            {field: 'type', condition: '==', value: 'Blog'},
            {field: 'status', condition: '==', value: 'Enabled'}
        ];

        const promptListResult = await searchPromptsWithSearchCriteria(searchCriteriaList);

        setPromptsList(promptListResult);
        setDataFetchInProgress(false);
    }

    const getCategoryConfig = async () => {
        const blogPostCategoryConfigResult: any = await getSingleContentConfig(CONTENT_CONFIG_KEYS.BLOG_POST_CATEGORY);
        let blogPostCategoryConfigData = blogPostCategoryConfigResult.data();
        // console.log('blogPostCategoryConfigData', blogPostCategoryConfigData);

        if (_.isEmpty(blogPostCategoryConfigData)) {
            blogPostCategoryConfigData = {};
            blogPostCategoryConfigData.id = CONTENT_CONFIG_KEYS.BLOG_POST_CATEGORY;
            blogPostCategoryConfigData.type = CONTENT_CONFIG_TYPES.BLOG_POST;
            blogPostCategoryConfigData.categories = [];
            await addSingleContentConfig(blogPostCategoryConfigData, blogPostCategoryConfigData.id);
        }

        setBlogPostCategoryConfig(blogPostCategoryConfigData);
        refreshBlogPostFilters(blogPostCategoryConfigData);
    }
    const getBlogPostList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        const blogPostListResult = await searchBlogPostsWithSearchCriteria(searchCriteriaList);
        // console.log('blogPostListResult', blogPostListResult, searchCriteriaList)

        setBlogPostsList(blogPostListResult);
        setDataFetchInProgress(false);
    }

    const refreshBlogPostList = async () => {
        await getBlogPostList();
        refreshBlogPostFilters();
    }

    const refreshBlogPostFilters = (blogPostCategoryConfigData?) => {
        const existingBlogPostCategoryConfig = blogPostCategoryConfigData || {...blogPostCategoryConfig};
        const blogPostFiltersResult = prepareBlogPostFilters(existingBlogPostCategoryConfig);
        setBlogPostFilters(blogPostFiltersResult);
    }

    const handleFilterChanges = (event) => {
        const existingFilterCriteria = {...filterCriteria};
        const {type, name, value} = event.target;

        if (type === 'checkbox') {
            existingFilterCriteria[name] = !existingFilterCriteria[name];
        } else {
            existingFilterCriteria[name] = value;
        }

        setFilterCriteria(existingFilterCriteria);
    }

    const clearFilterCriteria = () => {
        setFilterCriteria(emptyFilterCriteria);
    }

    const markAsPublishedBlogPost = async (blogPost, blogPostIndex) => {
        setDataFetchInProgress(true);
        const existingBlogPost = {...blogPost};
        existingBlogPost.status = 'Published';
        await updateSingleBlogPost(existingBlogPost);

        const existingBlogPostsList = [...blogPostsList];
        existingBlogPostsList[blogPostIndex] = existingBlogPost;
        setBlogPostsList(existingBlogPostsList);

        setDataFetchInProgress(false);
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start -mt-2 -ml-2 mb-2 w-full">
                    <div className="flex flex-wrap justify-start w-3/4">
                        {blogPostFilters &&
                            <RenderFields
                                parentForm={filterCriteria}
                                handleDetailChanges={handleFilterChanges}
                                fieldList={blogPostFilters}
                                enableEdit={true}
                                fieldClassName={'w-1/2'}/>
                        }
                    </div>

                    <div className="">
                        <button
                            onClick={() => clearFilterCriteria()}
                            className="button-small-link mt-9">
                            Clear Filters
                        </button>
                    </div>

                    <div className="ml-4 mt-9">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-full flex items-center justify-end">
                    <div className="ml-2 mr-2">
                        {blogPostCategoryConfig &&
                            <AddMultipleBlogPosts
                                blogPostCategoryConfig={blogPostCategoryConfig}
                                setBlogPostCategoryConfig={setBlogPostCategoryConfig}
                                refreshBlogPostList={refreshBlogPostList}/>
                        }
                    </div>

                    <div>
                        {blogPostCategoryConfig &&
                            <AddEditBlogPost
                                blogPostCategoryConfig={blogPostCategoryConfig}
                                setBlogPostCategoryConfig={setBlogPostCategoryConfig}
                                isAddBlogPost={true}
                                refreshBlogPostList={refreshBlogPostList}/>
                        }
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="shopify-table-container w-full overflow-y-scroll border-y border-gray-400 bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={blogPostsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Blog Posts'}/>

                    {blogPostsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">S.No</th>
                                {BLOG_POST_FIELDS_LIST?.map((blogPostField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white text-left pl-2 ${blogPostField?.cssClass}`}>{blogPostField?.label}</th>
                                ))}
                                <th className="p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {blogPostsList?.map((blogPost, blogPostIndex) => (
                                <tr key={`row-${blogPostIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center">
                                            {blogPostIndex + 1}
                                        </div>
                                    </td>

                                    {BLOG_POST_FIELDS_LIST?.map((blogPostField, columnIndex) => (
                                        <React.Fragment key={`column-${blogPostIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${blogPostField?.cssClass}`}>
                                                {blogPost[blogPostField?.attribute]}
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="p-2 border border-gray-400">
                                        {blogPostCategoryConfig &&
                                            <div className="flex justify-center items-center">
                                                <AddEditBlogPost
                                                    isEditBlogPost={true}
                                                    selectedBlogPost={blogPost}
                                                    refreshBlogPostList={refreshBlogPostList}
                                                    blogPostCategoryConfig={blogPostCategoryConfig}
                                                    setBlogPostCategoryConfig={setBlogPostCategoryConfig}/>

                                                {/*<GenerateBlogPostContent
                                                    promptsList={promptsList}
                                                    blogPost={blogPost}/>*/}

                                                <a href={`/content/blog-post/${blogPost.id}`}
                                                   className="button-purple-outline px-3 py-2 ml-2 mr-1">
                                                    <span>Design</span>
                                                </a>

                                                {blogPost.status === 'Ready' &&
                                                    <button
                                                        className="button-sky-outline px-3 py-2 m-1"
                                                        onClick={() => markAsPublishedBlogPost(blogPost, blogPostIndex)}>
                                                        Mark as Published
                                                    </button>
                                                }
                                            </div>
                                        }
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default BlogPostsList
